import './styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'flag-icons/css/flag-icons.min.css';
import Aurelia from 'aurelia';
import { RouterConfiguration } from '@aurelia/router';
import { I18nConfiguration } from '@aurelia/i18n';
import { App } from './app';
import { ConfirmDialog } from './components/confirm-dialog';
import { TagInput } from './components/tag-input';
import { PersonInput } from './components/person-input';
import { TagModal } from './components/tag-modal';
import { TagGroupModal } from './components/tag-group-modal';
import { MediaLightbox } from './components/media-lightbox';
import { ViewHeader } from './components/view-header';
import { MediaUploadProgress } from './components/media-upload-progress';
import { ImportProtocolDetailModal } from './components/import-protocol-detail-modal';
import { RuleModal } from './components/rule-modal';
import { PersonModal } from './components/person-modal';
import { PersonPicker } from './components/person-picker';
import { CollectionModal } from './components/collection-modal';
import { CollectionPicker } from './components/collection-picker';
import { MediaFoldModal } from './components/media-fold-modal';
import { MediaOwnerPicker } from './components/media-owner-picker';
import { CollectionTreeModal } from './components/collection-tree-modal';
import { CollectionTreeNode } from './components/collection-tree-node';
import { LocationMapModal } from './components/location-map-modal';
import { SortSelect } from './components/sort-select';
import { LocalizedDateInput } from './components/localized-date-input';
import { LocalizedDateTimeInput } from './components/localized-date-time-input';
import { AdvancedPersonFilterModal } from './components/advanced-person-filter-modal';
import { BulkDateModal } from './components/bulk-date-modal';
import { ChronologyOrderModal } from './components/chronology-order-modal';
import { DateValueConverter } from './converters/date';
import { DateTimeValueConverter } from './converters/date-time';
import { GalleryView } from './views/gallery-view';
import { TagsList } from './views/tags-list';
import { SettingsView } from './views/settings';
import { StatisticsView } from './views/statistics-view';
import { MaintenanceView } from './views/maintenance-view';
import { AppUpdatesView } from './views/app-updates-view';
import { ImportProtocolsList } from './views/import-protocols-list';
import { RulesList } from './views/rules-list';
import { PersonsList } from './views/persons-list';
import { PersonFaceRatings } from './views/person-face-ratings';
import { CollectionsView } from './views/collections-view';
import { HelpView } from './views/help-view';

import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';

const savedTheme = localStorage.getItem('radish-theme') ?? 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

const rawPath = window.location.pathname;
if (rawPath !== '/' && rawPath.endsWith('/')) {
  window.history.replaceState(null, '', rawPath.slice(0, -1) + window.location.search + window.location.hash);
}

Aurelia
  .register(
    RouterConfiguration.customize({
      useUrlFragmentHash: false,
      activeClass: 'active',
      basePath: '/',
    }),
    I18nConfiguration.customize(options => {
      options.initOptions = {
        lng: localStorage.getItem('radish-language') ?? 'en',
        fallbackLng: 'en',
        resources: {
          en: { translation: enTranslation },
          de: { translation: deTranslation },
        },
      };
    }),
    DateValueConverter,
    DateTimeValueConverter,
    ConfirmDialog,
    TagInput,
    PersonInput,
    TagModal,
    TagGroupModal,
    MediaLightbox,
    ViewHeader,
    MediaUploadProgress,
    ImportProtocolDetailModal,
    GalleryView,
    TagsList,
    SettingsView,
    StatisticsView,
    MaintenanceView,
    AppUpdatesView,
    ImportProtocolsList,
    RuleModal,
    RulesList,
    PersonModal,
    PersonPicker,
    PersonsList,
    PersonFaceRatings,
    CollectionModal,
    CollectionPicker,
    MediaFoldModal,
    MediaOwnerPicker,
    CollectionTreeModal,
    CollectionTreeNode,
    LocationMapModal,
    SortSelect,
    LocalizedDateInput,
    LocalizedDateTimeInput,
    AdvancedPersonFilterModal,
    BulkDateModal,
    ChronologyOrderModal,
    CollectionsView,
    HelpView,
  )
  .app(App)
  .start();
